import {
  SET_CANDIDATE_LIST_DATA,
  SET_CANDIDATE_METRICS_DATA,
  SET_JOB_ROLE_PREVIEW_DATA,
} from './action'
const initialState = {
  getJobRoleData: {},
  getCandidateListData: [],
  metricsData: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_JOB_ROLE_PREVIEW_DATA:
      return {
        ...state,
        getJobRoleData: action.data,
      }
    case SET_CANDIDATE_LIST_DATA:
      return {
        ...state,
        getCandidateListData: action.data,
      }
    case SET_CANDIDATE_METRICS_DATA:
      return {
        ...state,
        metricsData: action.data,
      }
    default:
      return state
  }
}
